
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutoriais/[slug]",
      function () {
        return require("private-next-pages/tutoriais/[slug].js");
      }
    ]);
  